module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/projects-verifiable-bookmarklets.json
// module id = 337
// module chunks = 28033720072838